import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';

function TabContainer(props) {
    return (
        <Typography component="div" style={{ paddingTop: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

const styles = theme => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    appBar: {
        backgroundColor: '#CFD8DC',
    },
    tab: {
        fontWeight: 'bold'
    }
});

class TabCustom extends React.Component {
    state = {
        value: 0,
    };

    handleChange = (event, value) => {
        this.setState({ value });
    }

    renderTabs() {
        const { classes } = this.props;
        var tabs = [];
        this.props.onglets.forEach(tab => {
            tabs.push(<Tab key={tab.label} label={tab.label} className={`${classes.tab} noDisabled`} />);
            }
        );
        return tabs;
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <AppBar position="static" /*color="default"*/ className={classes.appBar}>
                    <Tabs
                        value={this.state.value}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        fullWidth
                    >
                        {this.renderTabs()}
                    </Tabs>
                </AppBar>
                <TabContainer>{ this.props.onglets[this.state.value].content }</TabContainer>
            </div>
        );
    }
}

TabCustom.propTypes = {
    classes: PropTypes.object.isRequired,
    onglets: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        content: PropTypes.object.isRequired
    }))
};

export default withStyles(styles)(TabCustom);


// WEBPACK FOOTER //
// ./src/components/custom/tabs/TabCustom.js